import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import styles from "./WhatsAppButton.module.scss";
import FooterService from "../../layouts/Footer/footerServices/FooterServices";
import { SocialItem } from "../../layouts/Footer/Footer";

// TS-in xəta verməməsi üçün cast edirik
const WhatsappIcon = FaWhatsapp as React.ComponentType<{ size?: number }>;

const WhatsAppButton: React.FC = () => {
  const [socialAccount, setSocialAccount] = useState<SocialItem[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await FooterService.AllFooterSocialAccounts();
        setSocialAccount(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const handleClick = () => {
    const whatsapp = socialAccount?.find(
      (item: SocialItem) => item.key === "whatsap"
    );

    if (whatsapp?.value) {
      window.open(whatsapp.value, "_blank");
    }
  };

  return (
    <button
      className={styles.whatsapp}
      onClick={handleClick}
      aria-label="WhatsApp dəstəyi"
    >
      <WhatsappIcon size={30} />
    </button>
  );
};

export default WhatsAppButton;
